import { z } from 'zod';

export const keyDevsRequestSchema = z.object({
  entities: z.array(z.string()),
  filters: z.array(
    z.object({
      types: z.array(z.string()),
      start_date: z.string(),
    })
  ),
  page: z
    .object({
      number: z.number(),
      size: z.number(),
    })
    .optional(),
  sort_by: z
    .array(
      z.object({
        field: z.string(),
        desc: z.boolean(),
      })
    )
    .optional(),
});

export type KeyDevsRequest = z.infer<typeof keyDevsRequestSchema>;

const keyDevsObjectSchema = z.object({
  entity_tag: z.string(),
  event_type: z.string(),
  effective_date: z.string(),
  headline: z.string(),
  situation: z.string().optional(),
});

export type KeyDevsObject = z.infer<typeof keyDevsObjectSchema>;

export const keyDevsResponseSchema = z.object({
  key_devs: z.array(keyDevsObjectSchema),
  page: z.object({
    current: z.number(),
    next: z.number(),
    size: z.number(),
  }),
  total_count: z.number(),
});

export type KeyDevsResponse = z.infer<typeof keyDevsResponseSchema>;

const screenerFinancialEventsBasePath = 'financial-events/v1/';
export const screenerKeyDevelopments = {
  postKeyDevs: {
    path: `${screenerFinancialEventsBasePath}key-devs`,
    schema: keyDevsResponseSchema,
  },
};
